export { default } from "./Productos";
